// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMFormActions.tsx — standardized modal/form footer action row.
//
// Two layouts, matching the two patterns already in the app:
//   layout="end"  → text Cancel + filled primary pill, right-aligned
//                   (the New-task sheet pattern)
//   layout="fill" → equal-width outlined Cancel + filled confirm
//                   (the add-feature dialog pattern)
//
// Color rules follow the brand system: confirm is Forest Green (the GO color);
// pass `danger` for destructive confirms (Delete / Discard / End) which use
// Rose Red — the STOP/END color.

export function PMFormActions({
  onCancel,
  onConfirm,
  cancelLabel = "Cancel",
  confirmLabel = "Save",
  confirmIcon = null,
  confirmDisabled = false,
  danger = false,
  layout = "end",
  hideCancel = false,
  style = {},
}: any) {
  const confirmBg = danger ? "var(--pm-accent-critical)" : "var(--pm-primary)";
  const fill = layout === "fill";

  const confirmBtn = (
    <button
      onClick={onConfirm}
      disabled={confirmDisabled}
      style={{
        flex: fill ? 1 : "0 0 auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        padding: fill ? "13px 16px" : "12px 22px",
        background: confirmBg,
        color: "#fff",
        border: "none",
        borderRadius: "var(--pm-radius-pill)",
        cursor: confirmDisabled ? "not-allowed" : "pointer",
        opacity: confirmDisabled ? 0.45 : 1,
        font: "600 14px/1 var(--pm-font-sans)",
        boxShadow: "var(--pm-shadow-s)",
        transition: "opacity 150ms ease, background 150ms ease",
      }}
    >
      {confirmIcon}
      {confirmLabel}
    </button>
  );

  const cancelBtn = hideCancel ? null : (
    <button
      onClick={onCancel}
      style={
        fill
          ? {
              flex: 1,
              padding: "13px 16px",
              background: "transparent",
              color: "var(--pm-primary)",
              border: "1.5px solid var(--pm-primary)",
              borderRadius: "var(--pm-radius-pill)",
              cursor: "pointer",
              font: "600 14px/1 var(--pm-font-sans)",
            }
          : {
              flex: "0 0 auto",
              padding: "12px 16px",
              background: "transparent",
              color: "var(--pm-fg-2)",
              border: "none",
              borderRadius: "var(--pm-radius-pill)",
              cursor: "pointer",
              font: "600 14px/1 var(--pm-font-sans)",
            }
      }
    >
      {cancelLabel}
    </button>
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: fill ? "stretch" : "flex-end",
        gap: fill ? 12 : 8,
        ...style,
      }}
    >
      {cancelBtn}
      {confirmBtn}
    </div>
  );
}
